import {Trans} from '@lingui/macro';
import React from 'react';

import {
  VirtualTableColumnCellsEnum,
  virtualTableRowCheckboxWrapperWidth,
  virtualTableRowOffset,
} from '../../components/common/table/helpers/tableHelpers';
import {TableColumn} from '../../components/common/table/tableColumn';

export enum CircleEditorTeammateColumnsEnum {
  NAME = 'name',
  EMAIL = 'email',
  JOINED = 'joined',
}

export const circleEditorTeammateColumns: ReadonlyArray<TableColumn<CircleEditorTeammateColumnsEnum>> = [
  {
    id: CircleEditorTeammateColumnsEnum.NAME,
    type: CircleEditorTeammateColumnsEnum.NAME,
    title: <Trans id="circle-editor-teammate-name">Name</Trans>,
    cellType: VirtualTableColumnCellsEnum.TEAMMATE,
    settings: {
      sticky: {
        isSticky: true,
        stickyOffset: virtualTableRowCheckboxWrapperWidth,
      },
      cellWidth: {
        shouldFillRemainingWidth: true,
        minWidth: 282 - virtualTableRowOffset,
      },
    },
  },
  {
    id: CircleEditorTeammateColumnsEnum.EMAIL,
    type: CircleEditorTeammateColumnsEnum.EMAIL,
    title: <Trans id="circle-editor-teammate-email">Email</Trans>,
    cellType: VirtualTableColumnCellsEnum.TEXT,
    settings: {
      cellWidth: {
        width: 250,
      },
    },
  },
  {
    id: CircleEditorTeammateColumnsEnum.JOINED,
    type: CircleEditorTeammateColumnsEnum.JOINED,
    title: <Trans id="circle-editor-teammate-joined">Joined</Trans>,
    cellType: VirtualTableColumnCellsEnum.DATE,
    settings: {
      cellWidth: {
        width: 125,
      },
    },
  },
];
